import React, {Component} from 'react';
import AllocationCategory from '../AllocationCategory/AllocationCategory';
import { connect } from 'react-redux';
import classes from './CustomAllocations.css';
import {reduce} from 'ramda';

export class CustomAllocations extends Component {
    render() {

        let validationMessage = null;

        if (this.props.isAllocationValid) {
            validationMessage = (<div className={classes.validationMessage}>Please make sure all categories sum to 100%</div>)
        }

        let categories = this.props.allocation.assets.map((category) => {
            return (
                <AllocationCategory
                    key={category.assetId}
                    title={category.name}
                    categoryId={category.assetId}
                    assets={category.children}
                    total={category.value}
                    editable={this.props.editable}
                />
            );
        });

        let allocationsTotal = reduce((accum, asset) => {

            let newVal = parseFloat(asset.value);

            if (!isNaN(newVal)) {
                return accum + newVal;
            } else {
                return accum;
            }

        }, 0, this.props.allocation.assets);

        let totalDivClasses = [classes.totalDiv];

        if (allocationsTotal < 100.0 || allocationsTotal > 100.0) {
            totalDivClasses.push(classes.invalidTotal);
        }

        return (
            <div className={classes.CustomAllocations}>
                <div className={totalDivClasses.join(" ")}>
                    <label>Total:</label>
                    <span>{allocationsTotal}%</span>
                </div>
                {validationMessage}
                {categories}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        allocationId: state.planInfo.allocation.allocationId,
        allocation: state.planInfo.allocation,
        isAllocationValid: state.planInfo.allocation.invalid
    }
};

export default connect(mapStateToProps)(CustomAllocations);



// WEBPACK FOOTER //
// ./src/containers/CustomAllocations/CustomAllocations.js